module.exports = __webpack_public_path__ + "img/IMÁGENES CLÍNICAS KC7 3.3d95269b.png";